import superagentPromise from 'superagent-promise';
import _superagent from 'superagent';
import User from "./User";
import {LoaderObject} from "./LoaderDummy";

// const API_ROOT = "http://localhost:8000/api/v1"
// const FILES_ROOT = "http://localhost:8000/files/";

const API_ROOT = `https://api.bs1s.curzd.ru:443/api/v1`;
const FILES_ROOT = "https://api.bs1s.curzd.ru:443/files/";
const superagent = superagentPromise(_superagent, global.Promise);

const responseBody = res => {
    return res.body;
};
let user = new User();

const tokenPlugin = req =>{
    req.set('Content-Type', 'application/json');

    if(user.hasToken()){
        let value = 'JWT ' + user.getToken();

        req.set('Authorization', value);
    }

}
const tokenPluginFile = req =>{
    if(user.hasToken()){
        let value = 'JWT ' + user.getToken();

        req.set('Authorization', value);
    }

}
const requests = {
    del: url => {
        return superagent.del(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(function (err) {
            console.log(err)
            if (err.status === 401) {
                Auth.logout();
            }
        })
    },
    get: url => {
        return superagent.get(`${API_ROOT}${url}`).use(tokenPlugin).then(responseBody).catch(function (err) {

            console.log(err)
            if (err.status === 401) {
                Auth.logout();
            }
        })
    },
    put: (url, body) => {

        return superagent.put(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(function (err) {
            console.log(err)
            if (err.status === 401) {
                Auth.logout();
            }
        })
    },
    post: (url, body) => {

        return superagent.post(`${API_ROOT}${url}`, body).use(tokenPlugin).then(responseBody).catch(function (err) {
            console.log(err)

            console.log(err.response)
            if (err.status === 401) {
                Auth.logout();
            }
            return err.response;
        })
    },
    postFile: (url, file) =>
        superagent.post(`${API_ROOT}${url}`).attach('image', file).use(tokenPluginFile).then(responseBody).catch(function (err){
            console.log(err)
            if(err.status === 401){
                Auth.logout();
            }
        })
};

const Auth = {
    login: (username, password, onFinish, onError) =>{
        requests.post('/auth/login', {username:username, password:password}).then(function (response) {
            console.log(response);
            user.setToken(response.token);
            onFinish();
        }).catch(function (error){
            console.log(error);
            onError("Неправильное имя пользователя или пароль");
        });
    },
    refresh: (token) =>
        requests.post('/auth/refresh', { token:token }).then(function (response) {
            console.log(response)
            if (response && response.token) {
                user.setToken(response.token);
            }
        }),
    refresh_password: (username) => {
        requests.post('/auth/refresh-password', { username})
    },
    logout:()=>{
        user.setToken(null);
    }
};
const UserAPI =
{
    getProfile: (onFinish) => {
        return requests.get("/user/getProfile").then(function (profile) {
            onFinish(profile);
        });
    }
}

const Game = {
    reset:(gameID) => {
        return requests.post("/game/reset/" + gameID, null).then(function (response) {
            console.log(response)
        });
    },
    //player method
    info:(onFinish) => {
        return requests.get("/user/getProfile").then(function (response) {
            onFinish(response);
        });
    },
    getState:(id, onFinish) => {
        return requests.get("/game/state/" + id).then(function (response) {
            onFinish(response);
        });
    },
    setState:(id, state, onFinish) => {
        return requests.post("/game/state/" + id, {state:state}).then(function (response) {
            onFinish(response);
        });
    },
    setRole:(userRoles, onFinish) => {
        return requests.post("/game/role", userRoles).then(function (response) {
            onFinish(response);
        });
    },
    getGameList:(onFinish) => {
        return requests.get("/game/list").then(function (response) {
            onFinish(response);
        });
    },
    getPlayers:(gameID, onFinish) =>{
        return requests.get("/game/players/" + gameID).then(function (response) {
            onFinish(response);
        });
    },
    updateGame: (gameID, game, onFinish) => {
        console.log(JSON.stringify(game))
        return requests.post("/game/update/" + gameID, JSON.stringify(game)).then(function (response) {
            onFinish(response);
        });
    },
    readGame: (gameID, onFinish) => {
        return requests.get("/game/read/" + gameID).then(function (response) {
            onFinish(response);
        });
    },
    startGame:(gameID, onFinish) => {
        return requests.post("/game/start/" + gameID, "").then(function (response) {
            onFinish(response);
        });
    },
    setVote: (gameID, userID, onFinish) =>{
        return requests.post("/game/vote/set/" + gameID + "/" + userID, "").then(function (response) {
            onFinish(response);
        });
    },
    getVotes: (teamID, onFinish) =>{
        return requests.get("/game/vote/get/" + teamID).then(function (response) {
            onFinish(response);
        });
    },
    getTeamLogo: (teamID, onFinish) => {
        return requests.get("/game/image/team/" + teamID).then(function(response) {
            onFinish(response);
        })
    },
    sendImage(playerID, image, onFinish){
        return requests.postFile("/game/image/player/" + playerID, image).then(function (response) {
            onFinish(response);
        });
    },
    sendImageTeam(teamId, playerId, onFinish){
        return requests.post("/game/image/team/" + teamId, {playerId : playerId}).then(function (response) {
            onFinish(response);
        });
    },
    gameStatus(gameID, onFinish){
        return requests.get("/game/read/status/" + gameID).then(function (response) {
            onFinish(response);
        });
    },
    setGoals(teamID, goals, onFinish){
        return requests.post("/game/setGoals/" + teamID, {goals: goals}).then(function (response) {
            onFinish(response);
        });
    },
    setValues(teamID, values, onFinish){
        return requests.post("/game/setValues/" + teamID, values).then(function (response) {
            onFinish(response);
        });
    },
    runtimeLoad(teamID, onFinish) {
        return requests.get("/game/runtime/load/" + teamID).then(function(response) {
            onFinish(response);
        });
    },
    runtimeSave(teamID, data, onFinish) {
        return requests.post("/game/runtime/save/" + teamID, data).then(function(response) {
            onFinish(response);
        });
    },
    getGameSave(gameID, onFinish) {
        return requests.get("/game/getGameSave/" + gameID).then(function(response) {
            onFinish(response);
        });
    },
    setGameSave(gameID, data, onFinish) {
        return requests.post("/game/setGameSave/" + gameID, data).then(function(response) {
            onFinish(response);
        });
    },
}

const Integrations =
{
    getGeneralZoom: (gameID, onFinish) => {
        return requests.get("/integrations/get-general-zoom/" + gameID).then(function (response) {
            onFinish(response);
        });
    },
    getTeamZoom: (teamID,  onFinish) => {
        return requests.get("/integrations/get-team-zoom/" + teamID).then(function (response) {
            onFinish(response);
        });
    }
}
const Team =
{
    renameTeam: ( teamID, name, onFinish) => {
        return requests.post("/team/rename/" + teamID, {name: name}).then(function (response) {
            onFinish(response);
        });
    },
    callModerator: (teamID, onFinish) => {
        return requests.get("/team/call-moderator/" + teamID).then(function (response) {
            onFinish(response);
        });
    },
    movePlayer: (currentTeamID, playerID, newTeamID, onFinish) => {
        console.log("/team/movePlayer/" + currentTeamID)
        console.log({
            playerId: playerID,
            teamId: newTeamID
        })
        return requests.post("/team/movePlayer/" + currentTeamID, {
            playerId: playerID,
            teamId: newTeamID
        }).then(function(response) {
            onFinish(response);
        });
    }
}

const Moderator =
{
    checkStatus: (gameID, onFinish) =>{
        return requests.get("/moderator/check-moderator-status/" + gameID).then(function (response) {
            onFinish(response);
        });
    },
    endCallModerator: (teamID, onFinish) => {
        return requests.get("/team/end-call-moderator/" + teamID).then(function(response) {
            onFinish(response);
        })
    }
}
const GamePlay =
    {
        setDefault: (gameId, onFinish) =>{
            return requests.post("/game/gameplay/default/" + gameId).then(function (response) {
                onFinish(response);
            });
        },
        getGameData: (teamId, onFinish) =>{
            return requests.get("/game/gameplay/getGameData/" + teamId).then(function (response) {
                onFinish(response);
            });
        },
        startYear: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/startYear/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        startMorning: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/startMorning/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        startDay: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/startDay/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        startEvening: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/startEvening/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        startLateEvening: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/startLateEvening/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        endDay: (gameID, onFinish) =>{
            return requests.post("/game/gameplay/endDay/" + gameID).then(function (response) {
                onFinish(response);
            });
        },
        sortTrainSetState: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/sortTrainSetState/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        setPathRepairState: (teamID, data, onFinish) =>{
            return requests.post("/game/gameplay/setPathRepairState/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        moveLocoToRepair: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/moveLocoToRepair/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        createTrain: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/createTrain/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        freeTrain: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/freeTrain/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        setTrainToPath: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/setTrainToPath/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        removeTrainFromPath: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/removeTrainFromPath/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        investComplete: (teamID, data, onFinish) =>{
            console.log(data);
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/investComplete/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        buyLoco: (teamID, data, onFinish) =>{
            console.log(data);
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/buyLoco/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        buyParts: (teamID, data, onFinish) =>{
            console.log(data);
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/buyParts/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        buyContractors: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/buyContractors/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        buyAdditionalWorkhour: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            console.log(data);
            return requests.post("/game/gameplay/buyAdditionalWorkhour/" + teamID, data).then(function (response) {
                console.log(response);
                onFinish(response);
            });
        },
        addCreditCash: (teamID, data, onFinish) =>{
            console.log(data);
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/addCreditCash/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        changeTeamState: (teamID, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/changeTeamState/" + teamID).then(function (response) {
                onFinish(response);
            });
        },
        gameDataStatus: (teamID, onFinish) => {
            return requests.get("/game/gameplay/getGameData/status/" + teamID).then(function (response) {
                onFinish(response);
            });
        },
        setTrainCarPackOnGround: async (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            const response = await requests.post("/game/gameplay/setTrainCarPackOnGround/" + teamID, data);
            onFinish(response);
            LoaderObject.freeLoading();
            return response;
        },
        setTrainCarPackOnTrain: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/setTrainCarPackOnTrain/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        setLocoOnGround: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            console.log(data)
            return requests.post("/game/gameplay/setLocoOnGround/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        setLocoOnTrain: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/setLocoOnTrain/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        sellLoco: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/sellLoco/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        rentLoco: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/rentLoco/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        rentBrigade: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/rentBrigade/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        rentStationPlace: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/rentStationPlace/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        createOrder: (teamID, data, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/createOrder/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        stat: (teamID, year, onFinish) =>{
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/stat/" + teamID, {year:year} ).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        tenderPlaceOrder: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/tenderPlaceOrder/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        buyMarketingResearch: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/buyMarketingResearch/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        setLocoHot: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/game/gameplay/setLocoHot/" + teamID, data).then(function (response) {
                onFinish(response);
                LoaderObject.freeLoading();
            });
        },
        fixProfit: (teamID, data, onFinish) => {
            return requests.post("/game/gameplay/fixProfit/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        sellTrainCar: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/gameplay/sellTrainCar/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        rentTrainCar: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/gameplay/rentTrainCar/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        finishRentTrainCar: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/gameplay/finishRentTrainCar/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        },
        redemptionTrainCar: (teamID, data, onFinish) => {
            LoaderObject.setLoading();
            return requests.post("/gameplay/redemptionTrainCar/" + teamID, data).then(function (response) {
                onFinish(response);
            });
        }
    }
// eslint-disable-next-line import/no-anonymous-default-export
export default {
    Auth,
    UserAPI,
    Game,
    GamePlay,
    Team,
    Moderator,
    Integrations,
    user,
    FILES_ROOT
};
